import {TIME} from "../constants";
import {helpers} from "../helpers";

/** Класс c методами  */
export class UtilsShop {
	/**
	 * Функция запроса к серверу
	 * @param  {String} url
	 * @param  {Object|null} data
	 * @param  {String} type
	 * @param  {Boolean} parse
	 * @param  {Boolean} needOverlay
	 * @param  {Boolean} async
	 * @param  {Number} timeout
	 * @return {Promise}
	 */
	request(
		url,
		data = null,
		type = "POST",
		parse = true,
		needOverlay = true,
		async = true,
		timeout = 40000
	) {
		/**
		 * Если определен window.URL_PREFIX {string}
		 * То добавить префикс перед url
		 * @example {SITE_NAME}/tickets/ru/{url}
		 */
		if (window.URL_PREFIX) url = window.URL_PREFIX + url;

		return new Promise((succeed, fail) => {
			$.ajax({
				url,
				data,
				async,
				type,
				timeout,
				beforeSend: () => {
					if (needOverlay) {
						$("#js-overlay").show();
					}
				},
				success: response => {
					if (response) {
						if (parse) {
							try {
								succeed(JSON.parse(response));
							} catch (e) {
								succeed(response);
							}
						} else {
							succeed(response);
						}
					} else {
						succeed();
					}
				},
				complete: () => {
					if (needOverlay) {
						$("#js-overlay").hide();
					}
				},
				error: error => {
					if (needOverlay) {
						$("#js-overlay").hide();
					}
					fail(new Error(`Request failed: ${error.statusText}`));
				},
			});
		});
	}

	/**
	 * Функция заменяет пустой href у ссылок на некликабельный
	 * @param  {NodeList} links
	 */
	addVoidForLinks(links) {
		$.each(links, (index, element) => {
			const link = $(element);
			if (link.attr(`href`) === `` || link.attr(`href`) === `#`) {
				link.attr(`href`, `javascript:void(0)`);
			}
		});
	}

	textHideOrShow() {
		const eventText = $(".short-text");


		if (!eventText.length) {
			return false;
		}

		const wrapper = document.querySelector(".short-text__content");
		const eventShowButton = $(".js-more-text");

		if (helpers.isDesktop.matches) {
			if (wrapper.style.height > 87) {
				eventShowButton.addClass("active");
			}
			eventShowButton.on("click", () => {
				eventText.toggleClass("short");
				if (eventText.hasClass("short")) {
					eventShowButton.find("span").text("Показать всё");
				} else {
					eventShowButton.find("span").text("Скрыть");
				}
			});
			return true;
		}
		console.log('da');
		eventShowButton.find("span").text("Описание");
		wrapper.style.height = 0;

		eventShowButton.on("click", () => {
			eventText.toggleClass("short");
			if (eventText.hasClass("short")) {
				wrapper.style.height = 0;
				eventShowButton.find("span").text("Описание");
			} else {
				wrapper.style.height = 'auto';
				eventShowButton.find("span").text("Скрыть");
			}
		});

		return true;
	}

	/**
	 * Функция выполняющая вызов переданной функции не более одного раза в промежуток времени delay
	 * @param  {Function} callback
	 * @param  {Number|undefined} delay
	 * @return {Function}
	 */
	throttle(callback, delay) {
		let hold = false;
		delay = delay || TIME.THROTTLE;

		return function handleEvent(...args) {
			if (hold) return;

			hold = true;
			callback.apply(this, args);

			window.setTimeout(() => {
				hold = false;
			}, delay);
		};
	}

	/**
	 * Функция подствляет правильное окончание слова в зависимости от числа
	 * @param {Number} n
	 * @param {Array} forms
	 * @return {String}
	 * wordEnding(42, ["арбуз", "арбуза", "арбузов"]);
	 * 42 арбуза
	 */
	wordEnding(n, forms) {
		n = Math.abs(n) % 100;
		let n1 = n % 10;
		if (n > 10 && n < 20) {
			return forms[2];
		}
		if (n1 > 1 && n1 < 5) {
			return forms[1];
		}
		if (n1 === 1) {
			return forms[0];
		}
		return forms[2];
	}

	/**
	 * Функция убирающая повторы по имени свойства
	 * @param  {Array} array
	 * @param  {String} propertyName
	 * @return {Array}
	 */
	uniqueArrayByProperty(array, propertyName) {
		return array.filter(
			(e, i) => array.findIndex(a => a[propertyName] === e[propertyName]) === i
		);
	}

	setObjectToSessionStorage(name, object) {
		sessionStorage.setItem(name, JSON.stringify(object));
	}

	getObjectFromSessionStorage(name) {
		if (sessionStorage.getItem(name)) {
			return JSON.parse(sessionStorage.getItem(name));
		}
		return false;
	}

	setCookie(name, value, options) {
		options = options || {};

		let expires = options.expires;

		if (typeof expires === "number" && expires) {
			const d = new Date();
			d.setTime(d.getTime() + expires * 1000);
			expires = options.expires = d;
		}
		if (expires && expires.toUTCString) {
			options.expires = expires.toUTCString();
		}

		value = encodeURIComponent(value);

		let updatedCookie = `${name}=${value}`;

		for (const propName in options) {
			updatedCookie += `; ${propName}`;
			const propValue = options[propName];
			if (propValue !== true) {
				updatedCookie += `=${propValue}`;
			}
		}
		document.cookie = updatedCookie;
	}

	getCookie(name) {
		var matches = document.cookie.match(
			new RegExp(
				"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"
			)
		);
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	convertStringToObject(str) {
		const properties = str.split(";");
		const obj = {};
		properties.forEach(property => {
			const tup = property.split(":");
			obj[tup[0]] = tup[1];
		});
		return obj;
	}

	removeElementByValue(array, value) {
		return array.filter(item => item !== value);
	}

	getWord(path, word) {
		return window.languages[path][word]
			? window.languages[path][word]
			: $("html").attr("lang") === "en"
			? word
			: "";
	}
}

export const utils = new UtilsShop();
